export const Styles = {
    modalSpinner: { display: 'flex', margin: 'auto', padding: '26px 100px 20px 100px' },
};
